module.exports = __webpack_public_path__ + "img/kx5600-6.b888f1a1.png";